<template>
  <div>
    <div class="row">
      <div class="p-x-lg">
        <div class="col-sm-12 col-md-4">
          <div class="input-group m-t-xs w-xxl">
            <span class="input-group-addon no-border no-bg">
              <i class="fa fa-search opacity"></i>
            </span>
            <div class="profile-search">
              <input
                class="
                  form-control form-control-lg
                  no-border no-bg
                  search-input
                  ng-untouched ng-pristine ng-valid
                "
                v-model="searchTermFilter"
                placeholder="search directory"
                style="padding-left: 0"
                type="text"
                @keyup.enter="addSearchTermFilter"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-8 p-r-md">
          <div class="pull-right m-t-xs">
            <select2 v-model="selectedSort" :hideSearchBox="true">
              <option value="1">Last updated</option>
              <option value="2">A-Z</option>
              <option value="3">Z-A</option>
            </select2>
          </div>
          <div class="pull-right m-t-xs">
            <select2
              v-model="selectedSector"
              :options="sectors"
              :disabledValues="selectedSectors"
            >
              <option disabled value>Sector</option>
            </select2>
          </div>
          <div class="pull-right m-t-xs">
            <select2
              v-model="selectedType"
              :options="types"
              :disabledValues="selectedTypes"
            >
              <option disabled value>Type</option>
            </select2>
          </div>
          <div class="pull-right m-t-xs">
            <select2
              v-model="selectedIndustry"
              :options="industries"
              :disabledValues="selectedIndustries"
            >
              <option disabled value>Industry</option>
            </select2>
          </div>
        </div>
      </div>
    </div>
    <div v-if="filters.length > 0" class="row">
      <div class="p-x-lg">
        <div class="col-sm-12">
          <vue-tags-input
            :value="''"
            :tags="filters"
            :allow-edit-tags="true"
            :add-only-from-autocomplete="true"
            :placeholder="''"
            @tags-changed="filtersChanged"
          />
          <div class="filter-clear-button">
            <img
              @click="clearFilters"
              src="~@assets/img/clear-icon.png"
              width="24px"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row container--stretch">
      <div class="col-md-12 p-x-lg">
        <div class="container-fluid p-y">
          <div class="row">
            <div v-if="items">
              <div
                class="col-lg-3 col-md-4 col-sm-6 col-xs-12 m-b"
                v-for="(item, i) in items"
                :key="i"
              >
                <router-link :to="'/view/' + item.id">
                  <section
                    class="panel panel-default m-n list-items text-center"
                  >
                    <div class="text-center m-t-sm m-b-sm">
                      <lazy-img-loader
                        :mainImg="getCompanyImage(item)"
                        :imgAlt="item.name"
                        :imgWidth="128"
                        :imgHeight="128"
                      ></lazy-img-loader>
                    </div>
                    <div class="wrapper p-t-n">
                      <div>
                        <h4
                          class="
                            text-md
                            m-t-0 m-b-0
                            list-items__title
                            text-color
                          "
                        >
                          {{ item.name }}
                        </h4>
                      </div>
                      <div
                        class="
                          block
                          clear
                          text-sm
                          font-bold
                          text-muted
                          list-items__title
                        "
                      >
                        {{ item.industry ? item.industry.title : '' }}
                      </div>
                      <div
                        v-if="item.location.country_id"
                        class="text-xs text-muted"
                      >
                        <i class="fa fa-map-marker icon"></i>
                        <span v-if="item.location.city">{{
                          item.location.city
                        }}</span>
                        <span class="text-u-c">{{
                          getCountryName(item.location.country_id)
                        }}</span>
                      </div>
                    </div>
                  </section>
                </router-link>
              </div>
            </div>
            <div
              v-if="(!items || items.length == 0) && !loader"
              class="text-center text-muted"
              style="font-style: italic; text-transform: lowercase"
            >
              no items found
            </div>
            <div v-if="loader">
              <pre-loader></pre-loader>
            </div>
          </div>
          <div class="text-center row" v-if="pageCount >= page">
            <div class="text-center m-t">
              <button
                @click="fetchMoreProfiles"
                class="btn btn-s-md btn-sm btn-default org_list_more"
              >
                <i class="i i-arrow-down4"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from '@src/components/select2'
import LazyImgLoader from '@src/components/lazy-img-loader'
import ApiService from '@src/services/ApiService'

export default {
  data() {
    return {
      apiService: new ApiService(),
      accountService: new ApiService(process.env.ACCOUNT_URL, null, null),
      community: window.user.community_id,

      loader: false,
      page: 1,
      pageCount: null,
      items: [],

      filters: [],

      industries: [],
      selectedIndustry: null,
      selectedIndustries: [],

      types: [],
      selectedType: null,
      selectedTypes: [],

      sectors: [],
      selectedSector: null,
      selectedSectors: [],

      businessServices: [],
      countries: [],
      searchTermFilter: null,
      selectedSort: 1,
    }
  },
  watch: {
    filters() {
      this.fetchProfiles()
      this.updateSelectedFilters()
    },
    selectedSort() {
      this.fetchProfiles()
    },
    selectedIndustry() {
      if (
        this.industries.filter((e) => e.id == this.selectedIndustry).length > 0
      )
        this.filters.push({
          id: 'industry',
          value: this.selectedIndustry,
          text: this.industries.find((item) => item.id == this.selectedIndustry)
            .name,
        })
    },
    selectedType() {
      if (this.types.filter((e) => e.id == this.selectedType).length > 0)
        this.filters.push({
          id: 'type',
          value: this.selectedType,
          text: this.types.find((item) => item.id == this.selectedType).name,
        })
    },
    selectedSector() {
      if (this.sectors.filter((e) => e.id == this.selectedSector).length > 0)
        this.filters.push({
          id: 'sector',
          value: this.selectedSector,
          text: this.sectors.find((item) => item.id == this.selectedSector)
            .name,
        })
    },
  },
  components: {
    select2,
    LazyImgLoader,
  },
  created() {
    this.fetchCountries()

    if (Object.keys(this.$route.params).length > 0) {
      this.addQueryFiltersAndFetchProfiles() // this will trigger fetchProfiles()
    } else {
      this.fetchProfiles()
    }

    this.fetchIndustries()
    this.fetchTypes()
    this.fetchSectors()
  },
  beforeRouteUpdate(to, from, next) {
    // this.fetchMoreProfiles()
    next()
  },
  beforeRouteEnter(to, from, next) {
    next()
  },

  methods: {
    fetchProfiles() {
      this.page = 1
      this.items = []
      this.fetchMoreProfiles()
    },
    fetchMoreProfiles() {
      this.loader = true
      let queryParams = this.prepareQueryParams()
      this.apiService.get(`/corporate?${queryParams}`).then((res) => {
        if (this.page === 1) {
          this.items = res.items
          this.pageCount = res._meta.pageCount
        } else {
          this.items = this.items.concat(res.items)
        }
        this.page++
        this.loader = false
        this.selectedIndustry = null
        this.selectedType = null
        this.selectedSector = null
      })
    },
    prepareQueryParams() {
      let queryParams = `expand=industry&page=${this.page}&per-page=20&community=${this.community}`
      let industries = []
      let types = []
      let sectors = []
      let searchTermFilters = []
      let tagFilter = null
      this.filters.forEach((item) => {
        switch (item.id) {
          case 'industry':
            industries.push(item.value)
            break
          case 'type':
            types.push(item.value)
            break
          case 'sector':
            sectors.push(item.value)
            break
          case 'search':
            searchTermFilters.push(item.value)
            break
          case 'tag':
            tagFilter = item.value
            break
        }
      })

      if (industries.length > 0) queryParams += `&industry=${industries.join()}`
      if (types.length > 0) queryParams += `&type=${types.join()}`
      if (sectors.length > 0) queryParams += `&sector=${sectors.join()}`
      if (searchTermFilters.length > 0)
        queryParams += `&search=${searchTermFilters.join()}`
      if (tagFilter) queryParams += `&tag=${tagFilter}`

      switch (parseInt(this.selectedSort)) {
        case 1:
          queryParams += `&sort=-updated_at`
          break
        case 2:
          queryParams += `&sort=name`
          break
        case 3:
          queryParams += `&sort=-name`
          break
      }
      return queryParams
    },

    fetchBusinessService(id) {
      return this.accountService.get(`/api/business-services/${id}`)
    },
    fetchCountries() {
      this.accountService
        .get(`/api/countries`)
        .then((res) => (this.countries = res.data))
    },
    fetchIndustries() {
      this.accountService
        .get(`/api/industries`)
        .then((res) => (this.industries = res.data))
    },
    fetchTypes() {
      this.accountService
        .get(`/api/corporate-types`)
        .then((res) => (this.types = res.data))
    },
    fetchSectors() {
      this.accountService
        .get(`/api/sectors`)
        .then((res) => (this.sectors = res.data))
    },

    addQueryFiltersAndFetchProfiles() {
      if (this.$route.params.tag) {
        let businessServiceId = this.$route.params.tag
        this.fetchBusinessService(businessServiceId).then((res) => {
          this.filters.push({
            id: 'tag',
            value: res.data.id,
            text: res.data.name,
          })
        })
      } else if (this.$route.params.search) {
        this.filters.push({
          id: 'search',
          value: this.$route.params.search,
          text: this.$route.params.search,
        })
      } else {
        this.fetchProfiles()
      }
    },
    addSearchTermFilter() {
      this.filters.push({
        id: 'search',
        value: this.searchTermFilter,
        text: this.searchTermFilter,
      })
      this.searchTermFilter = null
    },
    filtersChanged(filters) {
      this.filters = filters
    },
    updateSelectedFilters() {
      this.selectedIndustries = []
      this.selectedTypes = []
      this.selectedSectors = []
      this.filters.forEach((item) => {
        switch (item.id) {
          case 'industry':
            this.selectedIndustries.push(parseInt(item.value))
            break
          case 'type':
            this.selectedTypes.push(parseInt(item.value))
            break
          case 'sector':
            this.selectedSectors.push(parseInt(item.value))
            break
        }
      })
    },
    clearFilters() {
      this.filters = []
      this.selectedIndustry = null
      this.selectedType = null
      this.selectedSector = null
      this.searchTermFilter = null
    },

    getCompanyImage(item) {
      return typeof item.profile.thumbs['thumb-lg'] !== 'undefined'
        ? item.profile.thumbs['thumb-lg']
        : item.profile.avatar
    },
    scrollToTop() {
      window.scrollTo(0, 0)
      document.getElementsByClassName('scrollable').scrollTop = 0
    },
    getCountryName(id = null) {
      if (!id) return ''
      const location = this.countries.find((country) => country.id === id)
      return location ? location.name : ''
    },
  },
}
</script>


<style lang="scss">
.list-items {
  &.div {
    margin-bottom: 1rem;
  }
}

.list-items {
  box-shadow: none !important;
  background: #fff;
  line-height: 1.42857143;
  transition: box-shadow 0.25s;
  max-width: 270px;
  height: 260px;
  display: block;
  border-radius: 0;
  border: 1px solid #eee !important;

  &:hover {
    box-shadow: 1px 1px #bbb, 1px 1px 1px 1px #ddd !important;
  }

  .list-item__image {
    width: 128px;
    height: 128px;
    object-fit: cover;
  }

  .list-items__title {
    white-space: normal;
    height: 52px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 18px; /* fallback */
    max-height: 34px; /* fallback */
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }

  .text-color {
    color: #000;
    font-weight: 500;
  }
}
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.lazy-img,
.lazy-image-main {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.select2-results .select2-highlighted {
  color: white !important;
  background-color: #337ab7;
}
.select2-drop-active {
  width: 200px !important;
}
.vue-tags-input {
  max-width: 100% !important;
  float: left;
  margin-right: 50px;
}
.vue-tags-input .ti-input {
  border: none;
}
.ti-tag {
  color: white !important;
  border: 1px solid #cbd5dd;
  background-color: #757575 !important;
  font-size: 14px !important;
  flex-direction: row-reverse;
  .ti-actions {
    margin-left: 0px !important;
    margin-right: 2px;
    font-size: 1em !important;
    .ti-icon-close {
      font-weight: 900 !important;
    }
  }
}
.filter-clear-button {
  position: absolute;
  right: 20px;
  top: 22%;
}
</style>
